export const parseData = (data) => ({
  maxSelections: data.maxSelections,
  deviceCategories: Object.freeze(data.deviceCategories),
  statusCode200: Object.freeze(data.statusCode200),
  statusCodeError: Object.freeze(data.statusCodeError),
  headerMessage: Object.freeze(data.headerMessage),
});
